import _ from 'lodash';
import axios from 'axios';

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {}

window._ = _;

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
